<template>
    <div class="layout">
        <the-header @operation="handleOperation" :enableCancel="enableRevoke" :enableRestore="enableRecovery" :isSpecial="isSpecial"></the-header>

        <main>
            <aside class="hierarchy">
                <ul class="nav">
                    <li @click="switchTab(0)" :class="{ active: navActivedIndex === 0 }">
                        <the-tip tip="场景">
                          <i class="iconfont icon-changjing"></i>
                        </the-tip>
                    </li>
                    <li @click="switchTab(1)" :class="{ active: navActivedIndex === 1 }">
                      <the-tip tip="背景">
                        <i class="iconfont icon-beijing"></i>
                      </the-tip>
                    </li>
                    <li @click="switchTab(2)" :class="{ active: navActivedIndex === 2 }">
                      <the-tip tip="标注">
                        <i class="iconfont icon-biaozhu"></i>
                      </the-tip>
                    </li>
                    <li @click="switchTab(3)" :class="{ active: navActivedIndex === 3 }">
                      <the-tip tip="后处理">
                        <i class="iconfont icon-houchuli"></i>
                      </the-tip>
                    </li>
                    <li @click="switchTab(4)" :class="{ active: navActivedIndex === 4 }">
                      <the-tip tip="动画">
                        <i class="iconfont icon-donghua"></i>
                      </the-tip>
                    </li>
                </ul>
                <div class="body" v-loading="!isSceneLoaded">
                    <MenuScene v-show="navActivedIndex === 0"/>
                    <MenuBackground v-show="navActivedIndex === 1"/>
                    <MenuHotspot v-show="navActivedIndex === 2"/>
                    <MenuProcessing :hasAnimation="hasAnimation" v-show="navActivedIndex === 3"/>
                    <MenuAnimation v-show="navActivedIndex === 4"/>
                </div>
            </aside>
            <div class="scene">
                <EditorMain :showPlan="navActivedIndex === 0" />
                <MaterialPLans v-if="navActivedIndex === 0" />
            </div>
            <aside class="inspector" v-show="currentInspector">
                <InspectorMaterial v-show="currentInspector === 'material'"/>
                <InspectorModel v-show="currentInspector === 'model'"/>
                <InspectorEnvironment v-show="currentInspector === 'environment'"/>
                <InspectorDirectionalLight v-show="currentInspector === 'directionalLight'"/>
                <InspectorHotspot v-show="currentInspector === 'hotspot'"/>
                <InspectorShadow v-show="currentInspector === 'shadow'"/>
            </aside>
            <AnimationController :sceneData="sceneData" v-show="hasAnimation" :style="animationContolsStyle" />
        </main>
        <the-share ref="shareObj" :url="shaderLink"></the-share>
        <the-guide></the-guide>
        <ExchangeList v-if="showExchange" @change="exchange" @close="showExchange = false" />
        <ReleaseSetting v-if="showRelease" @close="showRelease = false" />
    </div>
</template>
<script setup>
import { nextTick, onMounted, computed, ref, provide } from "vue";
import MenuScene from "./MenuScene.vue";
import MenuBackground from "./MenuBackground.vue";
import MenuHotspot from "./MenuHotspot.vue";
import MenuProcessing from "./MenuProcessing.vue";
import MenuAnimation from "./MenuAnimation.vue";
import InspectorMaterial from "./InspectorMaterial.vue";
import InspectorModel from "./InspectorModel.vue";
import InspectorEnvironment from "./InspectorEnvironment.vue";
import InspectorDirectionalLight from "./InspectorDirectionalLight.vue";
import InspectorHotspot from "./InspectorHotspot.vue";
import InspectorShadow from "./InspectorShadow.vue";
import EditorMain from "./EditorMain.vue";
import ExchangeList from "./ExchangeList.vue";
import ReleaseSetting from "./ReleaseSetting.vue";
import AnimationController from "components/AnimationController.vue";
import Hotspot from "./Hotspot.vue";
import MaterialPLans from "./MaterialPlans.vue";
import * as verify from "./verify";
import { $bus, Events } from "utils/eventBus.js";
import { saveModelData, fetchModelPaths, recordStart, startTime, modelInfo, sceneData } from "./data";
import { revoke, recovery, enableRevoke, enableRecovery, clear } from "./record";
import { model, viewer } from "utils/viewer";
import { ElLoading, ElMessageBox } from "element-plus";
import { importObsScript, copyToClipboard } from "utils/tool"
import { handlePoint } from "utils/point";
import axios from "utils/http"
import TheHeader from "../../components/TheHeader";
import TheShare from "../../components/TheShare";
import TheGuide from "../../components/TheGuide";
import TheTip from "../../components/TheTip";
import { useStore } from "vuex";
const store = useStore()
recordStart()
const hasAnimation = ref(false)
const animationContolsStyle = computed(() => {
    if(store.state.viewport == 'mobile'){
        return {
            width: viewer.containerRect.width + 'px',
            left:  `calc(50vw + ${currentInspector.value ? '50rem' : '200rem'} - ${viewer.containerRect.width / 2}px)`
        }
    }else{
        return {
            width: currentInspector.value ? 'calc(100% - 720rem)' : 'calc(100% - 420rem)',
            left: '405rem'
        }
    }
})
const navActivedIndex = computed(() => store.state.navActivedIndex), currentInspector = ref('')
provide('currentInspector', currentInspector)
const switchTab = tabIndex => {
    if (navActivedIndex.value == tabIndex) return
    store.commit("setNavActivedIndex", tabIndex)
    $bus.emit(Events.TabChange, tabIndex)
    $bus.emit(Events.SwitchInspector, '')
}
verify.setModelId()
onMounted(() => {
    importObsScript('libs/esdk-obs-browserjs-3.1.3.min.js')
    importObsScript('libs/huaweiOBSvue.js')
    verify.login()
})
const isSpecial = computed(() => verify.speicalCount.includes(verify.loginId.value))
const isSceneLoaded = ref(true)
const reset = () => {
    ElMessageBox.confirm('是否重置模型?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
    .then(() => window.location.reload())
    .catch(() => { })
}
const exit = () => {
    ElMessageBox.confirm('是否退出模型编辑?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
    .then(() => {
        handlePoint({
            tag: 'xgbjq',
            location: 'xgbjq',
            template: 'xgbjqdbcd',
            node: 'xgbjqtc'
        })
        axios.post('/api-transaction/laozi/v3/transaction/model/saveEditorUsageTime', {
            startTime,
            endTime: new Date().getTime(),
            type: 0
        }).finally(() => {
          window.open("about:blank", "_self").close()
            // const url = process.env.VUE_APP_MODE === 'pro' ? 'https://www.laozicloud.com/workbench/myModel' : 'https://www.laozicloud.net/workbench/myModel'
            // window.location.replace(url)
        })
    })
    .catch(() => { })
}
const showExchange = ref(false)
const exchange = val => {
    showExchange.value = false
    const envMap = viewer.sceneManager.envMapUrl
    const loading = ElLoading.service()
    fetchModelPaths(val.modelId).then(paths => {
        const matPath = paths.mat[0], scenePath = paths.scene
        model.applyMaterialFile({
            url: matPath,
            env: envMap,
            fromOthers: true,
            onTextureLoad: () => {
                loading.close()
                $bus.emit(Events.MatLoad)
                $bus.emit(Events.TextureLoad)
                clear()
            }
        })
        viewer.sceneManager.loadSceneFile(scenePath, {
            onLoad: config => {
                if (config.e) {
                    viewer.sceneManager.setEnvMap(config.e, () => {
                        viewer.sceneManager.setEnvMapIntensity(config.ei || 0.7)
                        viewer.sceneManager.setEnvMapRotation(config.ea || 0)
                        $bus.emit(Events.SceneLoad, config)
                    })
                } else {
                    $bus.emit(Events.SceneLoad, config)
                }
            }
        })
    })
}
$bus.on(Events.SceneLoad, () => {
    isSceneLoaded.value = true
})
$bus.on(Events.AnimationLoad, () => {
    hasAnimation.value = model.hasAnimation()
})
$bus.on(Events.MatLoad, () => {
    switchTab(0)
})
$bus.on(Events.SwitchInspector, value => {
    if(value === currentInspector.value) return
    currentInspector.value = value
    nextTick(() => viewer.resize())
})

// const workbrenchLink = process.env.VUE_APP_MODE === 'pro' ? 'https://www.laozicloud.com/workbench/myModel' : 'https://www.laozicloud.net/workbench/myModel'
const shaderLink = process.env.VUE_APP_MODE === 'pro' ? 'https://modelmall.laozicloud.com/pc/modelDetails?id=' + verify.modelId.value : 'https://www.laozicloud.net/transaction/detail?id=' + verify.modelId.value
// const mobileLink = `${process.env.VUE_APP_MODE === 'pro' ? 'https://m.laozicloud.com/' : 'https://m-t.laozicloud.com/'}tradingCenter/modelDetail?modelId=${verify.modelId.value}`
const showRelease = ref(false)
// const release = () => {
//     saveModelData(3, () => {
//         showRelease.value = false
//         qrcodeRef.value.innerHTML = ''
//         new QRCode(qrcodeRef.value, { width: 150, height: 150 }).makeCode(mobileLink)
//     })
// }
// $bus.on(Events.Release, release)
// const copy = () => {
//     copyToClipboard(shaderLink)
//     ElMessage.success('已复制到粘贴板')
// }
const toHelpPage = () => {
    window.open("https://docs.laozicloud.com/#/%E6%A8%A1%E5%9E%8B%E7%BC%96%E8%BE%91/%E6%95%88%E6%9E%9C%E7%BC%96%E8%BE%91%E5%99%A8/%E6%A6%82%E8%BF%B0")
}
const shareObj = ref(null);
function handleOperation(obj) {
    console.log(obj);
    const map = {
        help: toHelpPage,
        cancel: revoke,
        restore: recovery,
        reset: reset,
        save: saveModelData,
        exit: exit,
        reuse: () => showExchange.value = true,
        share: function () {
            shareObj.value.show();
            // showReleaseResult.value = true
            // qrcodeRef.value.innerHTML = ''
            // new QRCode(qrcodeRef.value, { width: 150, height: 150 }).makeCode(mobileLink)
        }
    }
    if (map[obj.type]) {
        if (obj.value) {
            map[obj.type](obj.value)
        } else {
            map[obj.type]()
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/style/editor.scss';
.nav{
  ::v-deep .the-tip{
    width: 100%;
    height: 100%;
    .tip-block{
      top: 40rem;
    }
    .block{
      color: #888;
      background: #272830;
      border-radius: 0;
      &:hover{
        background: #33343F;
      }
    }
  }
  .active{
    ::v-deep .the-tip{
      .block{
        color: #fff;
        background: #4D57FD;
      }
    }
  }

}
</style>
